import React from 'react';
import './App.css';
import DomainParking from './components/DomainParking';

function App() {
  return (
    <div className="App">
      <DomainParking />
    </div>
  );
}

export default App;
